import { getData, postData, delData } from '@/assets/js/api.js'
import { getSortType } from '@utils/utils'

// 获取第三方设备树
export const GetThirdPartDeviceCategoryTypeList = (params, fn) => {
  const methods = '/baseservice/ClassSku/GetThirdPartDeviceCategoryTypeList';

  // return {
  //   "Result": [
  //         {
  //             "SubList": [
  //                 {
  //                     "SubList": [

  //                     ],
  //                     "Id": 4194306,
  //                     "Key": 2,
  //                     "Name": "猫眼"
  //                 },
  //                 {
  //                     "SubList": [

  //                     ],
  //                     "Id": 4194305,
  //                     "Key": 1,
  //                     "Name": "摄像头"
  //                 }
  //             ],
  //             "Id": 4194304,
  //             "Key": 64,
  //             "Name": "安防"
  //         },
  //         {
  //           "SubList": [
  //               {
  //                   "SubList": [

  //                   ],
  //                   "Id": 4194306,
  //                   "Key": 2,
  //                   "Name": "猫眼"
  //               },
  //               {
  //                   "SubList": [

  //                   ],
  //                   "Id": 4194305,
  //                   "Key": 1,
  //                   "Name": "摄像头"
  //               }
  //           ],
  //           "Id": 4194304,
  //           "Key": 64,
  //           "Name": "安防"
  //       }
  //     ],
  //     "StatusCode": "0",
  //     "Message": "成功"
  // }


  return getData(methods, params, 1, fn)
}

// 获取第三方列表
export const GetTheThirdPartList2 = (params, fn) => {
  const methods = '/baseservice/ClassSku/GetTheThirdPartList';

  // return {
  //   "StatusCode": 0,
  //   "Message": "string",
  //   "Result": [
  //       {
  //           "ProductClass": 4096,
  //           "ProductSku": 4101,
  //           "ClassSku": "0x10001005",
  //           "ProductModel": null,
  //           "Name": "智能猫眼",
  //           "IconUrl": {
  //               "Figure": "https://appresource.opple.com/api/icon/sku/fig/10001005",
  //               "Line": "https://appresource.opple.com/api/icon/sku/line/10001005/on",
  //               "LED": "https://appresource.opple.com/api/icon/sku/led/10001005/on"
  //           },
  //           "ProtocolType": 1,
  //           "ProtocolTypeList": [
  //               {
  //                   "Id": 1,
  //                   "Key": 0,
  //                   "Name": "Wifi"
  //               }
  //           ],
  //           "DeviceType": 64,
  //           "DeviceTypeSubCategory": 2,
  //           "DeviceTypeList": [
  //               {
  //                   "SubList": [
  //                       {
  //                           "SubList": [

  //                           ],
  //                           "Id": 4194306,
  //                           "Key": 2,
  //                           "Name": "猫眼"
  //                       }
  //                   ],
  //                   "Id": 4194304,
  //                   "Key": 64,
  //                   "Name": "安防"
  //               }
  //           ],
  //           "IdentifyType": -1,
  //           "ControlType": 2,
  //           "FirmwareNum": 0,
  //           "UpgradeList": [
  //               {
  //                   "Id": 0,
  //                   "SourceType": 0,
  //                   "UpgradeType": 8,
  //                   "VersionList": null
  //               }
  //           ],
  //           "NetworkAccessType": 0,
  //           "DeviceSaveType": 0,
  //           "BrandType": 2,
  //           "IsSupportSceneTemplate": 1,
  //           "IsLowCapacity": false,
  //           "Remark": {

  //           }
  //       }
  //   ]
  // }

  return getData(methods, params, 1, fn)
}

// 添加第三方设备
export const AddThridPartGateway = (params, fn) => {
  const methods = '/api/Device/AddThridPartGateway';

  // return {
  //   "StatusCode": 0,
  //   "Message": "string"
  // }
  return postData(methods, params, 1, fn);
}

export const GetE2ETestingDeviceList = (params, fn) => {
  const methods = '/api/device/GetE2ETestingDeviceList';

  return getData(methods, params, 1, fn);
}

export const GetRouterListV2 = (params, fn) => {
  const methods = '/toolserviceapi/NetworkTesting/GetRouterListV2';

  return getData(methods, params, 1, fn);
}

export const GetRoatDevicelist = (params, fn) => {
  const methods = '/toolserviceapi/NetworkTesting/GetRouterListV2';

  return getData(methods, params, 1, fn);
}

// 添加第三方设备
export const BatchAddDevice1 = (params, fn) => {
  const methods = '/api/Area/BatchAddDevice1';

  return postData(methods, params, 1, fn);
}

//获取设备ota升级列表
export const FindCloudOtaVersionList = (params, fn) => {
  const methods = '/api/OTA/FindCloudOtaVersionListByClassSku';
  postData(methods, params, 1, fn)
}

export const BatchAddThirdPartDevice = (params, fn) => {
  const methods = '/api/Device/BatchAddThirdPartDevice';
  return postData(methods, params, 1, fn)
}

//针对于enocane设备添加
export const BatchAddThirdPartDeviceV1 = (params, fn) => {
  const methods = '/api/Device/BatchAddThirdPartDeviceV1';
  return postData(methods, params, 1, fn)
}

export const SetBLEProxy = (params) => {
  const methods = '/api/Device/SetBLEProxy';
  return postData(methods, params, 1);
}

// 获取设备类型列表
export const GetDeviceTypeList = fn => {
  const methods = '/api/Device/GetDeviceTypeList'
  getData(methods, {}, 2, fn)
}

export const GetTheThirdPartList = () => {
  return getData(`/baseservice/ClassSku/GetTheThirdPartList`, {}, 1)
}

export const GetGatewayListByTheThirdPartClassSku = (params) => {
  return getData(`/api/Device/GetGatewayListByTheThirdPartClassSku`, params, 1)
}

export const GetCanBecomeBLEProxiesDeviceList = (params) => {
  return getData(`/api/Device/GetCanBecomeBLEProxiesDeviceList`, params, 1)
}

// 获取设备的协议类型
export const GetProtocolTypeList = fn => {
  const methods = '/api/Device/GetProtocolTypeList'
  getData(methods, {}, 2, fn)
}

// 获取网关分类
export const GetGatewayCategoryList = fn => {
  const methods = '/api/Device/GetGatewayCategoryList'
  getData(methods, {}, 1, fn)
}

export const CheckDeviceBlockList = (params, fn) => {
  const methods = '/api/Device/CheckDeviceBlockList'
  return postData(methods, params, 1, fn)
}

// 获取设备分类
export const GetDeviceCategoryList = fn => {
  const methods = '/api/Device/GetDeviceCategoryList'
  getData(methods, {}, 1, fn)
}

// 获取设备分类（全部 含网关）
export const GetAllDeviceCategoryList = fn => {
  const methods = '/api/Device/GetAllDeviceCategoryList'
  getData(methods, {}, 2, fn)
}

// 获取网关列表
export const GetGatewayList = (params, fn) => {
  const methods = '/api/Device/GetGatewayList'
  getData(methods, params, 1, fn)
}

// 添加虚拟子设备
export const AddVirtualDevice = (params, fn) => {
  const methods = '/api/Device/AddVirtualDevice'
  postData(methods, params, 1, fn)
}

// 查询设备列表
export const FindDeviceListByPage = (params, fn) => {
  const methods = '/api/Device/FindDeviceListByPage'
  return getData(methods, params, 1, fn)
}

/* 虚拟设备接口 */
export const GetClassSkuList = (params, fn) => {
  const methods = '/api/Device/GetClassSkuList'
  return getData(methods, params, 1, fn)
}

/**
 * 新增虚拟设备接口
 * @param {*} params 
 * @param {*} Name 
 * @param {array} ChildCategoryTypes
 * @param {array} ProtocolTypes
 */
export const GetVirtualLibrary = (params, fn) => {
  const methods = '/api/Device/GetClassSkuListV2'
  return postData(methods, params, 1, fn)
}

// 查询设备列表不分页
export const FindDeviceList = (params, fn) => {
  const methods = '/api/Device/FindDeviceList'
  getData(methods, params, 1, fn)
}

// 修改设备名称和定位
export const ChangeName = (params, fn) => {
  const methods = '/api/Device/ChangeName'
  return getData(methods, params, 1, fn)
}

// 删除设备
export const Delete = (params, fn) => {
  const methods = '/api/Device/Delete'
  getData(methods, params, 1, fn)
}
// 批量删除设备
export const GroupDelete = (params, fn) => {
  const methods = '/api/Device/BatchDelete'
  return postData(methods, params, 1, fn)
}

// 获取设备树列表
export const GetDeviceTree = (params, fn) => {
  const methods = '/api/Device/GetDeviceTree'
  params.sortMode = getSortType()
  return getData(methods, params, 1, fn)
}

// 获取设备树列表
export const GetSimpleDeviceTree = (params, fn) => {
  const methods = '/api/Device/GetSimpleDeviceTree'

  return getData(methods, params, 1, fn)
}

export const GetDeviceCountForDeviceTree = (params, fn) => {
  const methods = '/api/Device/GetDeviceCountForDeviceTree'

  return getData(methods, params, 1, fn)
}


// 查询设备详情
export const FindDevice = (params, fn) => {
  const methods = '/api/Device/FindDevice'
  return getData(methods, params, 1, fn)
}

// 获取当前的Action状态
export const FindActionAbilityWithStatus = (params, fn) => {
  const methods = '/api/Device/FindActionAbilityWithStatus'
  return getData(methods, params, 1, fn)
}

// 获取设备action能力
export const FindActionAbility = (params, fn, cparameter) => {
  cparameter = cparameter || {}
  const methods = '/api/Device/FindActionAbility'
  getData(methods, params, 1, fn, cparameter)
}

// 获取设备action能力 (批量)
export const FindActionAbilityByClassSku = (params, fn,cparameter) => {
  const methods = '/api/Device/FindActionAbilityByClassSku'
  return getData(methods, params, 1, fn)
}
// 获取设备UI扩展能力 (批量)
export const FindActionAbilityByClassSkuUIConfig = (params, fn, cparameter) => {
  const methods = '/api/Device/FindUIAbilityList'
  return postData(methods, params, 1, fn)
}
/**
 * 获取设备action能力 (批量 加版本号)
 * @param {*} params 
 * @param ClassSku
 * @param FirmVersions
 * @param {*} fn 
 * @returns 
 */
export const FindActionAbilityByClassSkuV2 = (params, fn) => {
  const methods = '/api/Device/GetActionAbilityList'
  return postData(methods, params, 1, fn)
}

// 获取设备配置能力
export const FindConfigAbility = (params, fn) => {
  const methods = '/api/Device/FindConfigAbility'
  return getData(methods, params, 1, fn)
}

export const GetBLEProxyDeviceList = (params, fn) => {
  const methods = '/api/Device/GetBLEProxyDeviceList'
  return getData(methods, params, 1, fn)
}

// 批量配置参数
export const SetConfigs = (params, fn) => {
  const methods = '/api/Device/SetConfigs'
  return postData(methods, params, 1, fn)
}

// 批量设置专业复位模式
export const SetResetMode = (params, fn) => {
  const methods = '/api/Device/SetRestMode'
  postData(methods, params, 1, fn)
}

// 重启设备
export const Restart = (params, fn) => {
  const methods = '/api/Device/Restart'
  getData(methods, params, 1, fn)
}

// 恢复出厂设置
export const Reset = (params, fn) => {
  const methods = '/api/Device/Reset'
  getData(methods, params, 1, fn)
}

// 网关近端自动识别（客户端主动轮询）发现真实网关
export const GatewayIdentify = (params, fn) => {
  const methods = '/api/Device/GatewayIdentify';
  
  return getData(methods, params, 1, fn)
}

// 执行设备Action(设备控制)
export const CallAction = (params, fn) => {
  const methods = '/api/Device/CallAction'
  return getData(methods, params, 1, fn)
}

// 查询网关子卡数
export const GetGatewaySubNetNum = (params, fn) => {
  const methods = '/api/Device/GetGatewaySubNetNum'
  getData(methods, params, 1, fn)
}

// 添加真实网关
export const AddRealGateway = (params, fn) => {
  const methods = '/api/Device/AddRealGateway'
  
  return postData(methods, params, 1, fn)
}

// 发现子设备(开始扫描)
export const StartDiscovery = (params, fn) => {
  const methods = '/api/Device/StartDiscovery'
  return getData(methods, params, 1, fn)
}

// 停止发现子设备(停止扫描)
export const StopDiscovery = (params, fn) => {
  const methods = '/api/Device/StopDiscovery'
  
  return getData(methods, params, 1, fn)
}

// 根据网关获得子卡
export const GetGatewayDownLinkDetail = (params, fn) => {
  const methods = '/api/Device/GetGatewayDownLinkDetail'
  return getData(methods, params, 1, fn)
}
// 根据网关获得COM串口
export const GetComTypes = (params, fn) => {
  const methods = '/api/Device/GetComTypes'
  getData(methods, params, 1, fn)
}

// 创建第三方设备
export const AddThirdPartDevice = (params, fn) => {
  const methods = '/api/Device/AddThirdPartDevice'
  return postData(methods, params, 1, fn)
}

// 根据网关sku获得可以添加的设备
export const GetDeviceCategoryListByClassSku = (params, fn) => {
  const methods = '/api/Device/GetDeviceCategoryListByClassSku'
  getData(methods, params, 1, fn)
}

// 获取OTA升级列表
export const GetOTAList = (params, fn) => {
  const methods = '/api/Device/GetOTAList'
  getData(methods, params, 1, fn)
}

// 获得Trigger的设备
export const FindTriggerList = (params, fn) => {
  const methods = '/api/Device/FindTriggerList'
  getData(methods, params, 1, fn)
}

// 获取设备trigger能力
export const FindTriggerAbility = (params, fn, cparameter) => {
  cparameter = cparameter || {}
  const methods = '/api/Device/FindTriggerAbility'
  return getData(methods, params, 1, fn, cparameter)
}

// 获取action设备
export const FindActionList = (params, fn) => {
  const methods = '/api/Device/FindActionList'
  getData(methods, params, 1, fn)
}

// OTA升级
export const StartOta = (params, fn) => {
  const methods = '/api/Device/StartOta';

  return getData(methods, params, 1, fn)
}

// 获取设备状态列表
export const GetDeiveStatusList = fn => {
  const methods = '/api/Device/GetDeiveStatusList'
  getData(methods, {}, 1, fn)
}

// 获取设备实时状态
export const GetDeviceStatus = (params, fn) => {
  const methods = '/api/Device/GetDeviceStatus'
  return getData(methods, params, 1, fn)
}

// 获取支持最大功耗的子设备类别
export const GetMaxPowerClassSkuList = fn => {
  const methods = '/api/Device/GetMaxPowerClassSkuList'
  getData(methods, {}, 1, fn)
}

// 设置最大功率
export const SetMaxPower = (params, fn) => {
  const methods = '/api/Device/SetMaxPower';
  return postData(methods, params, 1, fn)
}

// 设置传感器延迟时间
export const SetSensorDelayTime = (params, fn) => {
  const methods = '/api/Device/SetSensorDelayTime'
  return postData(methods, params, 1, fn)
}

// 设置灯具渐变开关及时长 commandkey=0x80,0x81 两条命令  蓝牙设备
export const SetSwitchDelayTime = (params, fn) => {
  const methods = '/api/Device/SetSwitchDelayTime'
  return postData(methods, params, 1, fn)
}

// 设置灯具渐变开关及时长 dali设备
export const SetDaliDelayTime = (params, fn) => {
  const methods = '/api/Device/SetDaliDelayTime'
  return postData(methods, params, 1, fn)
}

// 设置渐变开关延时时间
export const SetGradualZhagaSwitchDelayTime = (params, fn) => {
	let methods = '/api/device/SetConverterFadeTime';
	return postData(methods, params, 1, fn)
};

// 查询设备认领方式
export const GetIdentifyInfo = (params, fn, model) => {
  const methods = '/api/Device/GetIdentifyInfo'
  getData(methods, params, 1, fn, model)
}

// 获取UI引导数据
export const GetUIGuideDataList = (params, fn, model) => {
  const methods = '/api/Device/GetUIGuideDataList'
  getData(methods, params, 1, fn, model)
}

// 主动识别 设备标识(给设备下发闪灯命令)
export const PositiveIdentify = (params, fn, model) => {
  const methods = '/api/Device/PositiveIdentify'
  getData(methods, params, 1, fn, model)
}

// 查询设备同步详情
export const FindDeviceSyncResult = (params, fn) => {
  const methods = '/api/Device/FindDeviceSyncResult'
  getData(methods, params, 1, fn)
}

// 重新设备同步项目下发
export const ReSyncProjectCode = (params, fn) => {
  const methods = '/api/Device/ReSyncProjectCode'
  getData(methods, params, 1, fn)
}
// 重新设备同步参数下发
export const ReSyncSmartConfig = (params, fn) => {
  const methods = '/api/Device/ReSyncSmartConfig'
  getData(methods, params, 1, fn)
}

// 查询照度传感器列表
export const FindIlluminanceSensorList = (params, fn) => {
  const methods = '/api/Device/FindIlluminanceSensorList'
  getData(methods, params, 1, fn)
}

// 查询传感器列表(所有)
export const FindAllSensorList = (params, fn) => {
  const methods = '/api/Device/FindAllSensorList'
  getData(methods, params, 1, fn)
}

// 获取设备状态能力
export const GetStatusAbility = (params, fn) => {
  const methods = '/api/Device/GetStatusAbility'
  getData(methods, params, 1, fn)
}

// 添加虚拟网关
export const AddVirtualGateway = (params, fn) => {
  const methods = '/api/Device/AddVirtualGateway'
  postData(methods, params, 1, fn)
}

// 查询可替换的设备列表（必须是新添加的设备）
export const GetCanBindList = (params, fn) => {
  const methods = '/api/Device/GetCanBindList'
  getData(methods, params, 1, fn)
}
// 查询可替换的设备列表（必须是新添加的设备）
export const GetCanBindListByPage = (params, fn) => {
  const methods = '/api/Device/GetCanBindListByPage'
  getData(methods, params, 1, fn)
}

// 绑定设备
export const Replace = (params, fn) => {
  const methods = '/api/Device/Replace'
  getData(methods, params, 1, fn)
}

// ota取消
export const StopOta = (params, fn) => {
  const methods = '/api/Device/StopOta'
  
  return getData(methods, params, 1, fn)
}

export const GetDeviceSupportFunctions = (params, fn) => {
  const methods = '/api/device/GetDeviceSupportFunctions'
  return postData(methods, params, 1, fn)
}

// Trigger分页
export const FindTriggerListByPage = (params, fn) => {
  const methods = '/api/Device/FindTriggerListByPage'
  getData(methods, params, 1, fn)
}

// Action分页
export const FindActionListByPage = (params, fn) => {
  const methods = '/api/Device/FindActionListByPage'
  getData(methods, params, 1, fn)
}
// 设备OTA - 查询设备版本 固件
export const SearchFirmwareVersion = (params, fn) => {
  const methods = '/api/Device/SearchFirmwareVersion1'
  getData(methods, params, 1, fn)
}

// 设备OTA - 查询设备版本 云端
export const SearchCloudOtaVersion = (params, fn) => {
  const methods = '/api/Device/SearchCloudOtaVersion'
  getData(methods, params, 1, fn)
}

// 设备OTA - 查询设备版本 (集成)
export const BatchSearchFirmwareVersion = (params, fn) => {
  const methods = '/api/Device/BatchSearchFirmwareVersion'
  return getData(methods, params, 1, fn)
}

export const GetDeviceVersion = (params, fn) => {
  const methods = '/api/Device/GetDeviceVersion'
  return getData(methods, params, 1, fn)
}

export const GetRootDeviceVersion = (params, fn) => {
  const methods = '/api/Device/GetRootDeviceVersion'
  return getData(methods, params, 1, fn)
}

// 设备OTA - 查询设备版本 (集成) ---拆分版本list
export const GetDeviceOtaVersionList = (params, fn) => {
  const methods = '/api/OTA/GetDeviceOtaVersionList'
  return getData(methods, params, 1, fn)
}

// 设备OTA - 查询设备版本 (集成) ---拆分升级ip
export const GetFirmwareVersionFromDevice = (params, fn) => {
  const methods = '/api/Device/GetFirmwareVersionFromDevice'
  return getData(methods, params, 1, fn)
}

// 查询设备列表(简约信息)
export const FindSimpleDeviceListByPage = (params, fn) => {
  const methods = '/api/Device/FindSimpleDeviceListByPage'
  return getData(methods, params, 1, fn)
}

// 保存批量设备照度校准数据
export const SaveOrUpdateDataSample = (params, fn) => {
  const methods = '/api/Device/SaveOrUpdateDataSample'
  postData(methods, params, 1, fn)
}

// 删除指定设备照度校准数据
export const DeleteDataSample = (params, fn) => {
  const methods = '/api/Device/BatchDeleteDataSample'
  getData(methods, params, 1, fn)
}

// 获取设备照度校准数据列表
export const GetDataSampleList = (params, fn) => {
  const methods = '/api/Device/GetDataSampleList'
  return getData(methods, params, 1, fn)
}

// 获取设备照度校准数据列表
export const GetHelpQA = (params, fn) => {
  const methods = '/baseservice/Common/GetHelpQA'
  return getData(methods, params, 1, fn)
}

// 重新下发
export const DeviceConfigRefresh = (params, fn) => {
  const methods = '/api/Device/DeviceConfigRefresh'
  return getData(methods, params, 1, fn)
}



// 获取开灯数据
export const GetOpenedOrClosedDeviceCount = (params, fn) => {
  const methods = '/api/Device/GetOpenedOrClosedDeviceCount'
  getData(methods, params, 1, fn)
}

// 批量设置专业复位模式
export const BatchSetResetMode = (params, fn) => {
  const methods = '/api/Device/SetRestMode'
  return postData(methods, params, 1, fn)
}

// 批量配置上电状态
export const BatchConfigurePowerOnState = (params, fn) => {
  const methods = '/api/Device/SetInitStatus'
  return postData(methods, params, 1, fn)
}
//批量设置CLO
export const BatchSetCLO = (params, fn) => {
  const methods = '/api/Device/SetCLO'
  return postData(methods, params, 1, fn)
}

// 设置dali渐变时长
export const SetDALISpeedRatioSwitchDelayTime = (params) => {
	let methods = '/api/device/SetDaliFadeRate';
	return postData(methods, params, 1)
};

// 场景选择设备的缩减字段列表
export const FindSummaryDeviceListByPage = (params, fn) => {
  const methods = '/api/Device/FindSummaryDeviceListByPage'
  getData(methods, params, 1, fn)
}

// ota引导
export const GetClassSkuUpgradeGuideDataList = (params, fn) => {
  const methods = '/api/Device/GetClassSkuUpgradeGuideDataList'
  getData(methods, params, 1, fn)
}

// 获取设备能力
export const FindDeviceAbilityByVDeviceId = (params, fn) => {
  const methods = '/api/Device/FindDeviceAbilityByVDeviceId'
   return getData(methods, params, 1, fn)
}

/** 灯具和面板绑定 - 华为地库 */
export const SetLightInterlockingSwitch = (params, fn) => {
  const methods = '/api/Device/SetLightInterlockingSwitch'
  return postData(methods, params, 1, fn)
}
/** 获取设备绑定的面板 - 华为地库 */
export const FindLightInterlockingSwitchDeviceListByCommandValue = (params, fn) => {
  const methods = '/api/Device/FindLightInterlockingSwitchDeviceListByCommandValue'
  return getData(methods, params, 1, fn)
}
// 获取设备能力
export const Finduiability = (params, fn, cparameter) => {
  const methods = '/api/Device/finduiability'
  return getData(methods, params, 1, fn,cparameter)
}

// 获取设备能力
export const GetAutoTemplateById = (params, fn, cparameter) => {
  const methods = '/baseservice/Auto/GetAutoTemplateById'
  return getData(methods, params, 1, fn,cparameter)
}

/**
 * 按区域统计设备信息
 * @param {Object} params 
 * @param {number} params.gpNo 区域编号
 */
export const GetDeviceSumByArea = (params) => {
  const methods = '/businessapi/Device/GetDeviceSumByArea'
  return getData(methods, params, 1)
}

/**
 * 按区域统计设备信息详情
 * @param {Object} params 
 * @param {number} params.GpNo 区域编号
 * @param {number[]} params.SumTypes 设备状态, 1 离线,2 告警,3 故障
 * @param {number} params.PageIndex 
 * @param {number} params.PageSize 
 */
export const GetDeviceInfoBySumType = (params) => {
  const methods = '/businessapi/Device/GetDeviceInfoBySumType'
  return postData(methods, params, 1)
}

/**
 * 查询光盒子点位
 * @param {Object} params 
 * 
 */
export const LightBoxPointBindQuery = (params) => {
  const methods = '/businessapi/design/LightBoxPointBindQuery';
  return getData(methods, params, 1)
}


/**
 * 更新光盒子点位mac
 * @param {Object} params
 * 
 */
export const UpdateLightBoxPointMac = (params) => {
  const methods = '/businessapi/design/UpdateLightBoxPointMac';
  return postData(methods, params, 1)
}


/**
 * 网关是否配网
 */ 
export const IsHasRealGateway = (params) => {
  const methods = '/businessapi/design/IsHasRealGateway'
  return getData(methods, params, 1)
}

/**
*
* ota验证
*/
export const OtaVerify = (params) => {
  const methods = '/businessapi/design/OtaVerify'
  return getData(methods, params, 1)
}

/**
 * 获取绑定设备列表
 */
export const LightBoxBindDeviceQuery = (params) => {
  const methods = '/businessapi/Design/LightBoxBindDeviceQuery'
  return getData(methods, params, 1)
}

/**
 * 查询是否有格兰斯贝设备
 * @param {*} params 
 * @returns 
 */
export const IsExistGSDevice = (params) => {
  const methods = '/api/Device/IsExistGSDevice'
  return getData(methods, params, 1)
}
/**
 * 情景号添加/修改
 * @param {*} params 
 * @returns 
 */
export const SaveOrUpdateThirdPartScene = (params) => {
  const methods = '/api/Scene/SaveOrUpdateThirdPartScene'
  return postData(methods, params, 1)
}
/**
 * 获取情景列表
 * @param {*} params 
 * @returns 
 */
export const GetThirdPartSceneList = (params) => {
  const methods = '/api/Scene/GetThirdPartSceneList'
  return getData(methods, params, 1)
}

/**
 * 下发自动化，场景，节目单
 */
export const LightBoxIssued = (params) => {
  const methods = '/api/ifttt/LightBoxIssued'
  return getData(methods, params, 1)
}

/**
 * 获取下发的自动化，场景，节目单数量
 */
export const GetLightBoxConfigCount = (params) => {
  const methods = '/businessapi/design/GetLightBoxConfigCount'
  return getData(methods, params, 1)
}

/**
 * 获取配置下发失败的设备列表
 */
export const GetFailDevice = (params) => {
  const methods = '/businessapi/design/FailDevice'
  return getData(methods, params, 1)
}

/**
 * 获取光盒子进程
 */
export const GetLightBoxProcess = (params) => {
  const methods = '/businessapi/design/GetLightBoxProcess';
  
  return getData(methods, params, 1);
}


/**
 * 更新光盒子进度
 */
export const UpdateLightBoxProcess = (params) => {
  const methods = '/businessapi/design/UpdateLightBoxProcess';

  return postData(methods, params, 1);
}

/**
 * 更新光盒子进度
 */
export const LightBoxDeviceStartDiscovery = (params) => {
  const methods = '/api/device/LightBoxDeviceStartDiscovery';

  return postData(methods, params, 1);
}

/**
 * 获取光盒子配置
 */
export const GetLightBoxTemplateDescs = (params, fn) => {
  const methods = '/api/common/GetLightBoxTemplateDescs';

  return getData(methods, params, 1, fn);
}

// 配置同步
export const AutoSync = (params, fn) => {
  const methods = '/api/SyncPanel/AutoSync';

  return getData(methods, params, 1, fn);
}

// 配置同步
export const AutoSyncBatch = (params, fn) => {
  const methods = '/api/SyncPanel/AutoSyncBatch';
  return postData(methods, params, 1);
}

/* 移动房间 */
export const LightBoxMoveArea = (params, fn) => {
  const methods = '/api/ifttt/LightBoxMoveArea';

  return getData(methods, params, 1, fn);
}

/**
 * 区域下是否存在区域映射记录
 * @param {*} params 
 * @returns 
 */
export const IsExistAreaAndAddressMap = (params) =>{
  const methods = '/api/Area/IsExistAreaAndAddressMap'
  return getData(methods, params, 1)
}

export const isSupportToggerAbility = (params) =>{
  const methods = '/api/Device/GetDeviceSupportFunctions'
  return postData(methods, params, 1)
}

// 获取网关分类
export const GetGatewayCategoryList2 = (params) => {
  const methods = '/baseservice/ClassSku/GetNetworkAcessLinkList';

  return getData(methods, params, 1);
}

// 获取网关分类
export const GetClassSkuResetGuideList = (params) => {
  const methods = '/api/Device/GetClassSkuResetGuideList';

  return getData(methods, params, 1);
}

// 获取天幕子设备
export const GetTianMuChildDeviceList = (params) => {
  const methods = '/api/SkyCanvas/GetSkyAuxiliaryDevice';

  return getData(methods, params, 1);
}

// 获取天幕设备方案库
export const  GetTianMuDevicePlanLibrary = (params)=>{
  const methods = '/businessapi/Scene/GetWellSkySceneListByPage';

  return postData(methods, params, 1);
}

// 新增自定义方案库
export const  AddPlanSceneLib = (params)=>{
  const methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/planSceneLib/save';
  return postData(methods, params, 1);
}

//删除自定义方案库
export const  DelPlanSceneLib = (params)=>{
  const methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/planSceneLib/delete';
  return postData(methods, params, 1);
}

//获取方案库详情
export const  GetPlanInfoDetail = (params) => {
  const methods = '/gateway/sdlroutefront/sdlfront/sdltool/light/sky/canvas/api/plan/findByPlanId';
  return getData(methods, params, 1);
}

//批量设置传感器灵敏度
export const SetSensorSensitivity = (params, fn) => {
  const methods = '/api/Device/SetSensitivity'
  return postData(methods, params, 1, fn)
}

// 获取传感器灵敏度列表
export const GetSensorSensitivityList = (params, fn) => {
  const methods = '/api/Device/GetSensitivityConfig'
  return getData(methods, params, 1, fn)
}
//获取天幕主设备
export const  GetMainDeviceByAuxiliary = (params)=>{
  const methods = '/api/SkyCanvas/GetMainDeviceByAuxiliary';
  return getData(methods, params, 1);
}


export const ResetDevicesInChannel = (params) => {
  const methods = '/api/Device/ResetDevicesInChannel';
  
  return getData(methods, params, 1);
}

//批量设置通道数名称
export const SetSwitchKeyName = (params,fn) => {
	let methods = `/api/Device/SetSwitchKeyName`;
	return postData(methods, params, 1, fn);
};

//批量获取通道数名称 针对农业项目的多回路灯
export const GetSwitchKeyNameList = (params, fn) => { 
  let methods = `/api/Device/GetSwitchKeyNameList`;
	return postData(methods, params, 1, fn);
};

export const GetRootDevicestatusListByPage = (params, fn) => { 
  let methods = `/api/device/GetRootDevicestatusListByPage`;
	return getData(methods, params, 1, fn);
};

export const GetE2ETestingDeviceListV2 = (params, fn) => { 
  let methods = `/api/device/GetE2ETestingDeviceListV2`;
	return getData(methods, params, 1, fn);
};

// OTA合并升级
export const StartCombineOta = (params, fn) => { 
  let methods = `/api/Device/StartCombineOta`;
	return getData(methods, params, 1, fn);
};

// 批量合并OTA升级
export const BatchStartCombineOta = (params, fn) => { 
  let methods = `/api/Device/BatchStartCombineOta`;
	return postData(methods, params, 1, fn);
};
export const saveFeifanPoint = (params, fn) => { 
  let methods = `/api/Scene/UpdatePointsToBinService`;
	return postData(methods, params, 1, fn);
};

//获取项目或区域内设备ClassSku列,需求来自九号科技，理论上来说只有第三方的设备才能配置额定功率
export const GetAvailableClassSkuList = (params, fn) => {
  const methods = '/api/device/GetAvailableClassSkuList'
  return getData(methods, params, 1, fn)
}

//设置classsku功率（可批量设备）
export const AddOrUpdateDeviceCategoryPowerConfig = (params, fn) => {
  const methods = '/businessapi/stat/AddOrUpdateDeviceCategoryPowerConfig'
  return postData(methods, params, 1, fn)
}

//删除classsku功率设置 (可批量删除)
export const DeleteCategoryPowerConfig = (params, fn) => {
  const methods = '/businessapi/stat/DeleteCategoryPowerConfig'
  return delData(methods, params, 1, fn)
}

//查询classsku功率设置列表
export const GetDeviceCategoryPowerConfigList = (params, fn) => {
  const methods = '/businessapi/stat/GetDeviceCategoryPowerConfigList'
  return getData(methods, params, 1, fn)
}

// 获取区域下农业传感器列表（绑定选择用）
export const GetAgricultureSensorList = (params, fn) => {
  const methods = '/api/device/GetAgricultureSensorList'
  return getData(methods, params, 1, fn)
}

// 获取区域下农业传感器绑定配置
export const GetAgricultureSensorConfigList = (params, fn) => {
  const methods = '/api/device/GetAgricultureSensorConfigList'
  return getData(methods, params, 1, fn)
}

// 绑定传感器到区域位置
export const BindAgricultureSensorPosition = (params, fn) => {
  const methods = '/api/device/BindAgricultureSensorPosition'
  return postData(methods, params, 1, fn)
}

//删除区域下传感器绑定 POST /api/device/DeleteAgricultureSensorPosition
export const DeleteAgricultureSensorPosition = (params, fn) => {
  const methods = '/api/device/DeleteAgricultureSensorPosition'
  return postData(methods, params, 1, fn)
}

//获取区域下农业传感器数据
export const GetAgricultureSensorDataByGpno = (params, fn) => {
  const methods = '/api/device/GetAgricultureSensorDataByGpno'
  return getData(methods, params, 1, fn)
}

//获取四路补光曲线数据
export const GetFourRoadLightCurveData = (params, fn) => {
  const methods = '/businessapi/stat/GetLightSupplementData'
  return getData(methods, params, 1, fn)
}









